import React, { useEffect } from "react";
import "../../../../../assets/css/custom.css";
import { Container, Col } from "react-bootstrap";
import {
  FaInstagramSquare,
  FaFacebookF,
  FaTwitterSquare,
  FaTripadvisor,
  FaYelp,
  FaTiktok,
} from "react-icons/fa";
import { ImYoutube2 } from "react-icons/im";
import Typography from "@mui/material/Typography";
import AOS from "aos";
import "aos/dist/aos.css";

const foreground = process.env.REACT_APP_FOREGROUND;
const backgroundColor = process.env.REACT_APP_BACKGROUND_COLOR;
const facebookLink = process.env.REACT_APP_LINK_FACEBOOK;
const instagramLink = process.env.REACT_APP_LINK_INSTAGRAM;
const twitterLink = process.env.REACT_APP_LINK_TWITTER;
const yelpLink = process.env.REACT_APP_LINK_YELP;
const tiktokLink = process.env.REACT_APP_LINK_TIKTOK;
const tripadvisorLink = process.env.REACT_APP_LINK_TRIPADVISOR;
const youtubeLink = process.env.REACT_APP_LINK_YOUTUBE;

export const SocialConnect = () => {
  useEffect(() => {
    AOS.init({
      duration: 300,
    });
  }, []);

  const socialLinks = [
    {
      href: facebookLink,
      icon: (
        <FaFacebookF style={{ fontSize: "1.5rem", marginRight: ".5rem" }} />
      ),
      alt: "Follow us on Facebook",
    },
    {
      href: instagramLink,
      icon: (
        <FaInstagramSquare
          style={{ fontSize: "1.5rem", marginRight: ".5rem" }}
        />
      ),
      alt: "Follow us on Instagram",
    },
    {
      href: twitterLink,
      icon: (
        <FaTwitterSquare style={{ fontSize: "1.5rem", marginRight: ".5rem" }} />
      ),
      alt: "Follow us on Twitter",
    },
    {
      href: yelpLink,
      icon: <FaYelp style={{ fontSize: "1.5rem", marginRight: ".5rem" }} />,
      alt: "Make a reservation on Yelp",
    },
    {
      href: tiktokLink,
      icon: <FaTiktok style={{ fontSize: "1.5rem", marginRight: ".5rem" }} />,
      alt: "Follow us on Tiktok",
    },
    {
      href: tripadvisorLink,
      icon: (
        <FaTripadvisor style={{ fontSize: "1.5rem", marginRight: ".5rem" }} />
      ),
      alt: "Write a review on Tripadvisor",
    },
    {
      href: youtubeLink,
      icon: <ImYoutube2 style={{ fontSize: "1.5rem", marginRight: ".5rem" }} />,
      alt: "Follow us on Youtube",
    },
  ];

  return (
    <div
      style={{ backgroundColor: backgroundColor, color: foreground }}
      className="social-connect"
      data-aos-easing="ease-in-out"
      data-aos-delay="0"
      data-aos="fade-bottom"
    >
      <Container
        className="social-icons aos-init aos-animate"
        data-aos="fade-top"
      >
        <Col xs={12} className="social-title">
          <Typography variant="h4" gutterBottom component="div">
            Social Connect
          </Typography>
        </Col>
        <Col xs={12} className="social-icons icon">
          <ul className="social-tags">
            {socialLinks.map((link, index) =>
              link.href ? (
                <li key={index}>
                  <a
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={link.alt}
                    style={{ color: foreground }}
                  >
                    <i className={`fab ${link.icon.props.className}`}>
                      {link.icon}
                    </i>
                    <span className="sr-only">{link.alt}</span>
                  </a>
                </li>
              ) : null
            )}
          </ul>
        </Col>
      </Container>
    </div>
  );
};
